export default [
  {
    title: 'Organisations',
    route: 'Organisations',
    icon: 'HomeIcon'
  },
  {
    title: 'Logout',
    route: 'logout',
    icon: 'PowerIcon'
  }
]
